import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle, Facebook, Linkedin } from "lucide-react";
import './TermsAndConditions.css';
import nobg from "../assets/images/noBG logo.png";

export default function TermsAndConditions() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="terms-root" dir="rtl">
            <nav className="terms-nav">
                <div className="terms-container nav-container">
                    <Link to="/">
                        <img src={nobg} alt="أمانك - Amanak" className="navbar-logo-img" />
                    </Link>
                    <Link to="/" className="back-home-link">
                        <ArrowRight size={20} />
                        الرجوع للرئيسية
                    </Link>
                </div>
            </nav>

            <main className="terms-main">
                <div className="terms-container content-container">
                    <header className="terms-header">
                        <h1>شروط وأحكام الاستخدام – نظام أمانك</h1>
                        <p className="last-updated">تاريخ آخر تحديث: 22 يناير 2026</p>
                    </header>

                    <section className="terms-intro">
                        <p>
                            يرجى قراءة هذه الشروط بعناية قبل البدء في استخدام خدماتنا. بمجرد تسجيلك أو استخدامك لنظام "أمانك" (عبر الموقع الإلكتروني أو تطبيق الهاتف)، فإنك تقر بموافقتك الكاملة والملزمة على هذه الشروط.
                        </p>
                    </section>

                    <div className="policy-grid">
                        <article className="policy-section">
                            <h2>1- تعريف الخدمة ونطاق الترخيص</h2>
                            <p>يمنحك "أمانك" ترخيصاً محدوداً، غير حصري، وغير قابل للتنازل لاستخدام النظام وفقاً للتفاصيل التالية:</p>
                            <ul>
                                <li><strong>أ. منصة الويب:</strong> هي واجهة الإدارة التشغيلية الكاملة. تمنحك (وموظفيك المصرح لهم) الصلاحية لإدارة المخزون، المشتريات، المبيعات، إدارة المستخدمين، وتعديل إعدادات النظام والأسعار.</li>
                                <li><strong>ب. تطبيق الهاتف:</strong> هو أداة مساعدة مخصصة لغرض "المراقبة والإشراف فقط". يتيح التطبيق استعراض البيانات والتقارير الحية للمخازن، ولا يمنح صلاحيات لإجراء عمليات تشغيلية (مثل البيع، التعديل، أو الحذف).</li>
                            </ul>



                            <h2>2- الحسابات والأمان</h2>
                            <ul>
                                <li><strong>1. أهلية الاستخدام:</strong> أنت تقر بأنك تمثل نشاطاً تجارياً قانونياً، وأن البيانات المقدمة عند التسجيل صحيحة ومحدثة.</li>
                                <li><strong>2. مسؤولية الحساب:</strong> أنت المسؤول الوحيد عن الحفاظ على سرية بيانات الدخول (اسم المستخدم وكلمة المرور).</li>
                                <li><strong>3. إدارة الموظفين:</strong> يتحمل صاحب الحساب الرئيسي (Founder) المسؤولية الكاملة عن الأنشطة التي يقوم بها الموظفون الذين منحهم صلاحيات الدخول للنظام (سواء أمناء مخازن أو محاسبين).</li>
                            </ul>


                            <h2>3- الاشتراكات والدفع</h2>
                            <ul>
                                <li><strong>1. الرسوم:</strong> يتم تقديم الخدمة بنظام الاشتراكات (شهرية / سنوية) وفقاً للباقات المعلنة أو المتفق عليها في العقد.</li>
                                <li><strong>2. التجديد والإيقاف:</strong> يجب تجديد الاشتراك في موعده لضمان استمرار الخدمة. يحتفظ "أمانك" بالحق في تعليق الوصول إلى النظام في حال عدم سداد المستحقات بعد انتهاء فترة السماح المقررة.</li>
                                <li><strong>3. تغيير الباقات:</strong> يحق للعميل طلب ترقية الباقة في أي وقت، وسيتم تطبيق الفارق المالي في الدورة الفوترية القادمة.</li>
                            </ul>

                            <h2>4- ضوابط استخدام البيانات والعمليات المالية</h2>
                            <ul>
                                <li><strong>1. دقة البيانات:</strong> العميل هو المسؤول الوحيد عن صحة ودقة البيانات المدخلة في النظام (أسماء الأصناف، الكميات، التكلفة، وأسعار البيع).</li>
                                <li><strong>2. أسعار الصرف (ميزة الدولار) والزيادة العامة:</strong> يوفر النظام ميزة تسعير مرتبطة بالدولار لتسهيل العمليات الحسابية. يقر العميل بأن إدخال "سعر الصرف" أو الزيادة العامة يتم يدوياً من قبله، ويتحمل العميل كامل المسؤولية عن أي تغيير في أسعار البيع ناتج عن إدخال سعر صرف خاطئ أو نسبة زيادة خاطئة. "أمانك" هي أداة حسابية فقط ولا تقدم مشورة مالية.</li>
                            </ul>

                            <h2>5- الإستخدام المحظور</h2>
                            <p>يُمنع منعاً باتاً استخدام النظام للأغراض التالية، ويحق لـ "أمانك" إنهاء الحساب فوراً دون تعويض في حال ثبوتها:</p>
                            <ul>
                                <li>1. إدارة أو تخزين سلع غير قانونية أو محرمة شرعاً وقانوناً.</li>
                                <li>2. محاولة اختراق النظام، أو إجراء هندسة عكسية للكود المصدري، أو نسخ واجهات النظام.</li>
                                <li>3. تأجير الحساب لطرف ثالث دون موافقة كتابية من "أمانك".</li>
                            </ul>

                            <h2>6- حقوق الملكية الفكرية</h2>
                            <ul>
                                <li><strong>1. النظام:</strong> جميع الحقوق المتعلقة بالبرمجيات، التصاميم، قواعد البيانات، والشعارات هي ملكية حصرية لمشروع "أمانك".</li>
                                <li><strong>2. بيانات العميل:</strong> جميع البيانات التجارية الخاصة بك (قوائم العملاء، المبيعات، المخزون) هي ملكية حصرية لك، ولنا الحق في استضافتها ومعالجتها لغرض تقديم الخدمة فقط.</li>
                            </ul>

                            <h2>7- التوفر والدعم الفني</h2>
                            <ul>
                                <li><strong>1. مستوى الخدمة:</strong> نسعى لضمان عمل النظام بنسبة 99%، باستثناء فترات الصيانة المجدولة التي يتم الإعلان عنها مسبقاً.</li>
                                <li><strong>2. انقطاع الخدمة:</strong> لا يتحمل "أمانك" المسؤولية عن توقف الخدمة الناتج عن أسباب خارجة عن إرادتنا (مثل انقطاع الإنترنت لدى العميل، أو الكوارث الطبيعية، أو تعطل خوادم الاستضافة العالمية).</li>
                            </ul>

                            <h2>8- حدود المسؤولية (إخلاء المسؤولية)</h2>
                            <p>لا يتحمل "أمانك" أي مسؤولية عن:</p>
                            <ul>
                                <li>• أي خسائر في الأرباح أو الإيرادات ناتجة عن استخدام النظام.</li>
                                <li>• الأخطاء البشرية في إدخال البيانات من قبل موظفي العميل.</li>
                                <li>• أي قرارات تجارية (شراء أو بيع) تم اتخاذها بناءً على تقارير النظام. النظام يقدم البيانات كما هي بناءً على مدخلاتكم.</li>
                            </ul>

                            <h2>9- التعديلات على الشروط</h2>
                            <p>
                                يحتفظ "أمانك" بالحق في تحديث هذه الشروط في أي وقت لمواكبة التغيرات القانونية أو التقنية. سيتم إشعار المستخدمين بأي تعديلات جوهرية عبر البريد الإلكتروني أو رسالة واتساب في رقم العميل المسجل مع الحساب. واستمرارك في استخدام النظام بعد التعديل يعتبر موافقة عليه.
                            </p>

                            <h2>10- القانون الواجب التطبيق</h2>
                            <p>
                                تخضع هذه الشروط وتفسر وفقاً للقوانين والأنظمة المعمول بها في (دولة السودان)، ويتم اللجوء للمحاكم المختصة في حال النزاع.
                            </p>

                            <h2>تواصل معنا</h2>
                            <p>فريق الدعم الفني في أمانك متاح دائماً عبر وسائل التواصل الإجتماعي:</p>
                            <ul className="contact-links">
                                <li>
                                    <a href="https://api.whatsapp.com/message/STKXQTAFDC37A1?autoload=1&app_absent=0" target="_blank" rel="noopener noreferrer">
                                        <MessageCircle size={20} />
                                        واتساب
                                    </a>
                                </li>
                                <li>
                                    <a href="https://web.facebook.com/profile.php?id=61586860653173" target="_blank" rel="noopener noreferrer">
                                        <Facebook size={20} />
                                        فيسبوك
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/amanak/" target="_blank" rel="noopener noreferrer">
                                        <Linkedin size={20} />
                                        لينكد إن
                                    </a>
                                </li>
                            </ul>
                        </article>
                    </div>
                </div>
            </main>

            <footer className="terms-footer">
                <div className="terms-container">
                    <p>© {new Date().getFullYear()} أمانك (Amanak). جميع الحقوق محفوظة.</p>
                </div>
            </footer>
        </div>
    );
}
